<template>
    <div :class="preCls + 'content-box'">
        <Layout>
            <Sider
                hide-trigger
                style="background: #fff; border-radius: 0"
                :width="440"
            >
                <!-- 词典分类 -->
                <div>
                    <table-tool-bar>
                        <Button
                            v-if="$can('add')"
                            type="primary"
                            size="default"
                            :disabled="disabled"
                            @click="showFather = true"
                            style="margin-right: 12px"
                            >新增分类</Button
                        >
                    </table-tool-bar>
                    <Table
                        highlight-row
                        :data="fatherData"
                        :columns="columns1"
                        :loading="parentLoading"
                        :height="mtHeight"
                        @on-current-change="selectDict"
                    ></Table>
                </div>
                <smart-modal
                    title="新增词典分类"
                    v-model="showFather"
                    :height="300"
                    :width="600"
                    :maskClosable="maskClosable"
                    @close-by-confirm="reset"
                >
                    <add-father-dict
                        v-if="showFather"
                        :prodId="prodId"
                    ></add-father-dict>
                </smart-modal>
                <smart-modal
                    title="修改词典分类"
                    v-model="showDictForm"
                    :height="300"
                    :width="600"
                    :maskClosable="maskClosable"
                    @close-by-confirm="reset"
                >
                    <dict-form
                        v-if="showDictForm"
                        :pid="pid"
                        :id="id"
                        :ver="ver"
                        :prodId="prodId"
                    ></dict-form>
                </smart-modal>
            </Sider>
            <Content
                style="padding-left: 20px; background: #fff; border-radius: 0"
            >
                <!-- 词典条目 -->
                <div>
                    <table-tool-bar>
                        <Button
                            v-if="$can('add')"
                            type="primary"
                            size="default"
                            @click="showSon = true"
                            :disabled="isDis"
                            style="margin-right: 12px"
                            >新增词典</Button
                        >
                    </table-tool-bar>
                    <smart-modal
                        v-model="showSon"
                        title="新增词典"
                        :maskClosable="maskClosable"
                        :height="300"
                        :width="600"
                        @close-by-confirm="fetchChild"
                    >
                        <add-son-dict
                            v-if="showSon"
                            :pid="spid"
                            :prodId="prodId"
                        ></add-son-dict>
                    </smart-modal>
                    <Table
                        ref="mt"
                        draggable
                        :columns="columns2"
                        :data="childData"
                        :loading="loading"
                        :height="mtHeight"
                        @on-drag-drop="onChildDragDrop"
                    >
                    </Table>
                    <smart-modal
                        title="修改词典"
                        v-model="showDictSonForm"
                        :height="380"
                        :width="600"
                        :maskClosable="maskClosable"
                        @close-by-confirm="fetchChild"
                    >
                        <dict-son-form
                            v-if="showDictSonForm"
                            :pid="pid"
                            :id="id"
                            :ver="ver"
                            :prodId="prodId"
                        ></dict-son-form>
                    </smart-modal>
                </div>
            </Content>
        </Layout>
    </div>
</template>
<style scoped>
.dict-li {
    list-style-type: none;
    cursor: pointer;
    font-size: 14px;
    margin-top: 10px;
}

.delete-action {
    width: 36px;
    height: 20px;
    background-color: #ececec;
    font-size: 12px;
    color: cadetblue;
    text-align: center;
    float: right;
    line-height: 10px;
    padding-top: 5px;
    border-radius: 10px;
    margin-right: 5px;
}

.delete-action:hover {
    box-shadow: 2px 2px 1px #ccc;
}

.li-item:hover {
    color: lightblue;
    font-weight: 200;
}

.ul-box {
    height: 309px;
}
</style>
<script>
import {
    dictTree,
    dictAdd,
    dictDelete,
    dictUpdate,
    dictSort,
} from '@/api/sys-dict'
import { Button, PoptipButton } from 'ivux'
import { createNamespacedHelpers } from 'vuex'
import { anchorCell, mapCell } from '@/components/grid/renderCell'
import { listToTree } from '_u/helper'
import addFatherDict from './addFatherDict'
import addSonDict from './addSonDict'
import dictForm from './dictForm'
import dictSonForm from './dictSonForm'

const WINDOW_HEIGHT = document.body.clientHeight

export default {
    components: {
        addFatherDict,
        addSonDict,
        dictForm,
        dictSonForm,
    },
    data() {
        return {
            maskClosable: false,
            parentLoading: false,
            loading: false,
            mtHeight: 360,
            prodId: '0',
            id: '',
            pid: '',
            spid: '',
            ver: '',
            disabled: true,
            childData: [],
            showFather: false,
            showSon: false,
            showDictForm: false,
            showDictSonForm: false,
            //treeData:[],
            fatherData: [],
            buttonProps: {
                type: 'default',
                size: 'small',
            },
        }
    },
    computed: {
        columns2() {
            return [
                {
                    type: 'index',
                    width: 80,
                    align: 'center',
                    title: '序号',
                },
                {
                    title: '词典名称',
                    className: 'drag-handle',
                    key: 'name',
                },
                {
                    title: '词典代码',
                    key: 'code',
                },
                {
                    title: '操作',
                    align: 'center',
                    width: 190,
                    render: this.chileAction,
                },
            ]
        },

        columns1() {
            return [
                {
                    align: 'left',
                    title: '词典分类',
                    key: 'name',
                },
                {
                    align: 'left',
                    title: '分类代码',
                    key: 'code',
                },
                {
                    title: '操作',
                    align: 'center',
                    width: 125,
                    render: this.parentAction,
                },
            ]
        },

        isDis() {
            return this.spid == ''
        },
    },
    methods: {
        fillData(args) {
            var [tenantProds] = args
            store.commit('tenant/tenantProds/setProds', tenantProds.data)
        },

        fetch() {
            this.parentLoading = true
            this.disabled = true

            dictTree(this.prodId)
                .then((res) => this.setTreeData(res))
                .finally(() => {
                    this.parentLoading = false
                    this.disabled = false
                })
        },

        setTreeData(dict) {
            var list = dict.data.list.filter((v) => v.pid == 0)
            this.fatherData = list
        },

        reset() {
            this.fetch(this.prodId)
            // 子级清空
            this.childData = []
        },

        fetchChild() {
            this.fetchSon(this.spid)
        },

        selectDict(currentRow) {
            this.spid = currentRow.id
            this.fetchSon(currentRow.id)
        },

        fetchSon(id) {
            this.loading = true
            this.spid = id
            return dictTree(id).then((res) => {
                this.childData = res.data.list
                this.loading = false
            })
        },

        deleteSonDict(id) {
            dictDelete(id).then((res) => {
                this.$Message.success(this.$t('tips.delete.success'))
                this.fetchChild()
            })
        },

        deleteParentDict(id) {
            dictDelete(id).then((res) => {
                this.$Message.success(this.$t('tips.delete.success'))
                this.reset()
            })
        },

        parentAction(h, { row, column, index }) {
            return (
                <div>
                    {this.$can('update') ? (
                        <Button
                            type="default"
                            size="small"
                            style={{
                                marginRight: '5px',
                            }}
                            onClick={() =>
                                this.updatefatherDict(row.id, row.ver, row.pid)
                            }
                        >
                            {' '}
                            修改{' '}
                        </Button>
                    ) : (
                        ''
                    )}
                    {this.$can('delete') ? (
                        <PoptipButton
                            type="default"
                            transfer
                            title="您确定删除这条记录吗?"
                            text="删除"
                            ok={() => this.deleteParentDict(row.id)}
                        >
                            {' '}
                            删除{' '}
                        </PoptipButton>
                    ) : (
                        ''
                    )}
                </div>
            )
        },

        chileAction(h, { row, column, index }) {
            return (
                <div>
                    {this.$can('update') ? (
                        <Button
                            type="default"
                            size="small"
                            style={{
                                marginRight: '5px',
                            }}
                            onClick={() =>
                                this.updateDict(row.id, row.ver, row.pid)
                            }
                        >
                            {' '}
                            修改{' '}
                        </Button>
                    ) : (
                        ''
                    )}
                    {this.$can('delete') ? (
                        <PoptipButton
                            type="default"
                            transfer
                            title="您确定删除这条记录吗?"
                            text="删除"
                            ok={() => this.deleteSonDict(row.id)}
                        >
                            {' '}
                            删除{' '}
                        </PoptipButton>
                    ) : (
                        ''
                    )}
                </div>
            )
        },

        updateDict(id, ver, pid) {
            this.ver = ver
            this.id = id
            this.pid = pid
            this.showDictSonForm = true
        },

        append() {
            this.showFather = true
        },

        updatefatherDict(id, ver, pid) {
            this.ver = ver
            this.id = id
            this.pid = pid
            this.showDictForm = true
        },

        onChildDragDrop(index1, index2) {
            var targetId = this.childData[index1].id,
                type,
                relativeId = ''

            // 未移动
            if (index1 == index2) {
                return
            }

            // 上移
            if (index2 < index1) {
                // 置顶
                if (index2 == 0) {
                    type = 1
                    relativeId = ''
                } else {
                    type = 3
                    relativeId = this.childData[index2 - 1].id
                }
            }
            // 下移
            else {
                // 置低
                if (index2 == this.childData.length - 1) {
                    type = 2
                    relativeId = ''
                } else {
                    type = 3
                    relativeId = this.childData[index2].id
                }
            }

            // 后台顺序变更
            dictSort(targetId, type, relativeId)
            // 前端顺序改变
            this.childData.splice(
                index2,
                0,
                this.childData.splice(index1, 1)[0]
            )
        },
    },
    created() {
        this.fetch()
    },
    mounted() {
        var me = this

        //this.fetch()

        this.$nextTick(() => {
            var mt = this.$refs.mt
            me.mtHeight =
                WINDOW_HEIGHT - mt.$el.getBoundingClientRect().top - 20
        })
    },
}
</script>
